//🇫🇷
export const frCommons = {
    COMMON_SAVE: 'Enregistrer',
    COMMON_DELETE: 'Supprimer',
    COMMON_CONTINUE: 'Continuer',
    COMMON_CANCEL: 'Annuler',
    COMMON_QUIT: 'Quitter',
    COMMON_YES: 'Oui',
    COMMON_NO: 'Non',
    COMMON_OK: 'OK',
    COMMON_OR: 'ou',
    COMMON_VALIDATE: 'Valider',
    COMMON_CLEAR: 'Effacer',
    COMMON_DATE_DEFAULT_VALUE: '?',
    COMMON_USER_FULLNAME: '{firstName} {lastName}',
    COMMON_WARNING: 'Attention !',
    COMMON_NEXT: 'Suivant',
    COMMON_PREVIOUS: 'Précédent',
    COMMON_OTHER: 'Autre',
    COMMON_LOADING: 'Chargement...',
    COMMON_REFRESH: 'Rafraîchir',
    COMMON_ADD: 'Ajouter',
    COMMON_EDIT: 'Éditer',
    COMMON_MODIFY: 'Modifier',
    COMMON_FINISH: 'Terminer',

    COMMON_ERROR_TITLE: 'Erreur : {code}',
    COMMON_SORRY_TITLE: 'Désolé,',
    COMMON_SORRY_TITLE_WITHOUT_COMMA: 'Désolé',
    COMMON_ERROR_MESSAGE: "Quelque chose ne s'est pas passé comme prévu, merci de réessayer.",

    COMMON_BACK: 'Retour',
    COMMON_BACK_TO_MAP: 'Revenir au plan',
    COMMON_CONFIRM_OPERATION_REQUEST: "Confirmez-vous l'opération ?",

    COMMON_DIMENS: 'Dimension',
};